import * as React from 'react';

import classnames from 'classnames';

import {Card} from '../card/card';
import {ErrorList} from '../error-list/error-list';
import {Truncated} from '../truncated/truncated';
import {useResizeObserver} from '../utils/hooks/use-resize-observer';

import styles from './action-box.module.css';

type Props = {
    title?: string | React.ReactElement<any>;
    subtitle?: string | React.ReactElement<any>;
    icon?: React.ReactElement<any>;
    actionElement: React.ReactElement<any> | null | undefined;
    size: 'small' | 'large';
    errors?: string[];
    shouldTruncate?: boolean;
    isBorderless?: boolean;
};

export function ActionBox(props: Props) {
    const actionboxStyleName =
        props.size === 'large' ? styles['action-box'] : styles['action-box--small'];

    const containerRef = React.useRef(null);
    const [width, setWidth] = React.useState(0);

    React.useEffect(() => {
        if (containerRef.current) {
            // @ts-expect-error
            setWidth(containerRef.current.getBoundingClientRect().width);
        }
    }, [containerRef]);

    const [newWidth] = useResizeObserver(containerRef.current);

    React.useEffect(() => {
        if (typeof newWidth === 'number') {
            setWidth(newWidth);
        }
    }, [newWidth]);

    return (
        <Card hasBorder={!props.isBorderless} hasShadow={false} fitHeight={true}>
            <div className={classnames('pad-16 flex align-center justify-sb', actionboxStyleName)}>
                {/* @ts-expect-error */}
                <div ref={(ref) => (containerRef.current = ref)} className='flex align-center'>
                    {props.icon ? <div className={styles.icon}>{props.icon}</div> : undefined}
                    <div>
                        {props.shouldTruncate ? (
                            <div
                                style={{width: width && `calc(${width}px - 32px)`}}
                                className={styles.title}
                            >
                                <Truncated title={props.title ? props.title.toString() : ''}>
                                    {props.title || ''}
                                </Truncated>
                            </div>
                        ) : (
                            <div className={styles.title}>{props.title}</div>
                        )}
                        <div className={styles.body}>{props.subtitle}</div>
                        {props.errors && props.errors.length ? (
                            <ErrorList errors={props.errors} />
                        ) : null}
                    </div>
                </div>
                {props.actionElement}
            </div>
        </Card>
    );
}

ActionBox.defaultProps = {
    size: 'large',
};
